/**
 * Copyright (c) Microsoft. All rights reserved.
 */
export class BaseTokenStore {
    constructor(index, text) {
        this.index = index;
        this.text = text;
    }
}
